var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zm0 3.543a1.354 1.354 0 110 2.708 1.354 1.354 0 010-2.708zm1.806 8.188a.381.381 0 01-.382.382H8.581a.382.382 0 01-.381-.382v-.772a.382.382 0 01.382-.382h.381V10.51h-.381a.382.382 0 01-.382-.382v-.77a.382.382 0 01.382-.386h2.057a.382.382 0 01.382.382v3.225h.381a.382.382 0 01.38.382l.024.771z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default ForwardRef;